import { gql } from '@apollo/client';
import commentFragment from './commentFragment';

const EDIT_EVENT_COMMENT = gql`
  mutation EditEventComment($comment: EditAppraiserEventCommentInput!) {
    editEventComment(comment: $comment) {
      ...CommentFields
    }
  }

  ${commentFragment}
`;

export default EDIT_EVENT_COMMENT;
